export const OPEN_MERGE_COMMAND_DRAWER = 'OPEN_MERGE_COMMAND_DRAWER';
export const openDrawer = () => ({ type: OPEN_MERGE_COMMAND_DRAWER });

export const CLOSE_MERGE_COMMAND_DRAWER = 'CLOSE_MERGE_COMMAND_DRAWER';
export const closeDrawer = () => ({ type: CLOSE_MERGE_COMMAND_DRAWER });

export const GET_COMMANDS_FOR_MERGE = 'GET_COMMANDS_FOR_MERGE';
export const GET_COMMANDS_FOR_MERGE_SUCCESS = 'GET_COMMANDS_FOR_MERGE_SUCCESS';
export const GET_COMMANDS_FOR_MERGE_FAILURE = 'GET_COMMANDS_FOR_MERGE_FAILURE';
export const getCommandsForMerge = commandsIds => ({
  type: GET_COMMANDS_FOR_MERGE,
  payload: commandsIds
});

export const MERGE_COMMANDS = 'MERGE_COMMANDS';
export const MERGE_COMMANDS_SUCCESS = 'MERGE_COMMANDS_SUCCESS';
export const MERGE_COMMANDS_FAILURE = 'MERGE_COMMANDS_FAILURE';
export const mergeCommands = data => ({
  type: MERGE_COMMANDS,
  payload: data
});
